<template>
  <section class="wrap dark">
    <div class="container-wrap">
      <div class="observer-selector">
        <div class="title">
          급할 때는 급송으로<br class="mobile" />
          빠르게 보내요
        </div>
        <div class="title-sub" style="margin-top: 12px">
          급송 선택 시 전담 CS팀에서<br class="mobile" />
          빠른 배차를 도와드려요
        </div>
      </div>
      <div class="box-wrap observer-selector">
        <div class="content purple">
          <div>이곳 저곳 들르지 않고</div>
          <div class="bold">바로 배송해야 할 때</div>
          <div class="img-wrap">
            <img src="@/assets/img/home/express_car.png" />
          </div>
        </div>
        <div class="content yellow">
          <div>신선식품이라</div>
          <div class="bold">빠른 배송이 필요할 때</div>
          <div class="img-wrap">
            <img src="@/assets/img/home/express_fresh.png" />
          </div>
        </div>
        <div class="content blue">
          <div>급하게</div>
          <div class="bold">서류를 보내야 할 때</div>
          <div class="img-wrap">
            <img src="@/assets/img/home/express_document.png" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style src="../home.common.css" scoped />
<style scoped>
.mobile {
  display: block;
}
.box-wrap {
  margin-top: 40px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}

.content {
  border-radius: 32px;
  padding: 32px 32px 20px 32px;
  font-size: 20px;
  line-height: 28px;
  font-weight: 300;
  color: var(--gray-700);
  word-break: break-all;
  white-space: pre-wrap;
}
.content.purple {
  background-color: var(--secondary-200);
}

.content.yellow {
  background-color: var(--gray-200);
}

.content .img-wrap {
  display: flex;
  justify-content: center;
}
.content img {
  max-width: 220px;
  width: 100%;
  height: auto;
}

.content.blue {
  background-color: var(--primary-200);
}

.bold {
  font-weight: 500;
}

@media (min-width: 1024px) {
  .box-wrap {
    grid-template-columns: 1fr 1fr 1fr;
    margin-top: 56px;
  }
  .content {
    font-size: 24px;
    line-height: 32px;
  }
  .mobile {
    display: none;
  }
}
</style>
